<template>
  <div style="padding-top: 180px;">
    <div style="position: fixed;
    margin: auto;
    padding: 10px 30px;
    background: #f7f7ff;
    right: 0px;
    left: 12px;
    transition: all 0.2s;" :class="scroll > 50 ? 'floating' : summary ? 'header-floating-open' : 'header-floating'" :style="loading ? 'opacity: 0;' : 'opacity: 1;'">

    <div class="columns">
      <div class="column is-two-thirds">    
        <p ><a @click="prev">Back to All Accounts</a></p>
        <p class="title is-3">{{appnum}}</p>
        <p class="subtitle is-5">{{account.name}} - {{account.accnum}}</p>
      </div>
      <div class="column" style="text-align: right;">
        <p class="subtitle is-6">{{account.institution}}</p>
        <p class="subtitle is-5">Refreshed {{formatUnixTS(account.timestamp)}}</p>
        <p class="subtitle is-4">Balance: <strong>${{numberWithCommas(balance, true)}}</strong></p>
      </div>
      
      </div>
      <div v-if="resp.months.length > 0" style="text-align: center;">
        <div href="#" @click="viewSummary()" style="cursor: pointer;" v-if="!summary">View Summary <br><i class="fas fa-chevron-down"></i></div>
        <div href="#" @click="viewSummary()" style="cursor: pointer;" v-else><i class="fas fa-chevron-up"></i></div>
        <table class="table is-narrow is-bordered" style="margin-top: 20px;" v-if="summary">
          <thead>
            <tr>
              <th></th>
              <th>Month</th>
              <th>Transactions</th>
              <th>Deposits</th>
              <th>MG</th>
              <th>ADB</th>
              <th>NEDs</th>

            </tr>
          </thead>
          <tbody>
            <tr v-for="month in resp.months" v-bind:key="month.id" :class="isFullMonth(month) ? '' : 'incomplete-row'">
              <td style="text-align: center;"><i class="fas fa-exclamation-triangle" v-if="!isFullMonth(month)"></i><i class="fas fa-check" v-else></i></td>
              <td>{{month.month}}</td>
              <td>{{month.txs}}</td>
              <td>{{month.deps}}</td>
              <td>${{numberWithCommas(month.mg, true)}}</td>
              <td>${{numberWithCommas(month.adb, true)}}</td>
              <td>{{month.neds}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    
    <table class="table is-striped is-hoverable is-narrow">
    <thead>
      <tr>
        <th>Date</th>
        <th>Amount</th>
        <th>Description</th>
        <th>Running Balance</th>

      </tr>
    </thead>
    <tbody>
      <tr v-for="tx in sortedArray" v-bind:key="tx.id[0]">
        <td>{{formatUnixDate(tx.postedDate[0])}}</td>
        <td>{{numberWithCommas(tx.amount[0], true)}}</td>
        <td>{{tx.description[0]}}</td>
        <td>${{numberWithCommas(tx.runningBalance, true)}}</td>

      </tr>
    </tbody>
  </table>
  </div>
</template>

<script>
import $ from "jquery";
import Input from "@/components/shared/Input";
import moment from "moment";
export default {
  name: "Account",
  components: {},
  props: {
    appnum: String,
    resp: Object,
    account: Object
  },
  data() {
    return {
      loading: true,
      balance: 0,
      accountId: null,
      scroll: 0,
      txs: [],
      summary: false
    };
  },
  computed: {
    sortedArray: function() {
      function compare(a, b) {
        if (a.postedDate[0] < b.postedDate[0])
          return -1;
        if (a.postedDate[0] > b.postedDate[0])
          return 1;
        return 0;
      }
      var arr = []
      var self = this
      self.txs.forEach((tx) => {
        if (tx.accountId[0] == this.accountId){
          arr.push(tx)
        }
      })
      arr = arr.sort(compare).reverse();
      var balance = self.balance
      arr.forEach((tx) => {
        tx.runningBalance = balance
        balance -= parseFloat(tx.amount[0])
      })

      return arr
    }
  },
  calculated: {},
  methods: {
    formatUnixTS(ts) {
      // console.log("formatting", ts);
      return moment.unix(ts).format("l LT");
    },
    formatUnixDate(ts) {
      // console.log("formatting", ts);
      return moment.unix(ts).format("l");
    },
    numberWithCommas(val, money = false){
      if (money)
        val = parseFloat(val).toFixed(2)
      var returnval = null
      if (val != null)
        returnval = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (returnval == 'NaN')
        returnval = '0.00'

      return returnval
    },
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    },
    prev() {
      this.loading = true
      this.$emit("prev", this.$data)
    },
    scrollY(){
      this.scroll = window.top.scrollY
      // console.log(this.scroll)
    },
    isFullMonth(month){
      let refreshed = moment(month.stamp)

      let refreshedSixMo = moment(month.stamp).subtract(6, 'months')

      let monthMoment = moment(month.month+'-01')
      
      let endOfMonth = moment(month.month+'-'+String(monthMoment.daysInMonth()).padStart(2, '0'))
      console.log('refreshed', refreshed)
      console.log('refreshedSixMo', refreshedSixMo)
      console.log('monthmoment', monthMoment)
      console.log('endofmonth', endOfMonth)

      if (endOfMonth.isAfter(refreshed) || monthMoment.isBefore(refreshedSixMo)){
        return false
      }
      return true
    },
    viewSummary(){
      this.summary = !this.summary
    }
  },
  mounted: function() {
    this.balance = parseFloat(this.account.balance)
    this.accountId = this.account.accountid
    this.txs = JSON.parse(this.resp.urls.txs)
    setTimeout(() => {
      this.loading = false
    }, 500)
    
    window.addEventListener("scroll", this.scrollY)
  },
  beforeDestroy: function() {
    window.removeEventListener("scroll", this.scrollY)
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header-floating {
    top: 0px;
    transform: scale(0.9) translateY(80px);
    box-shadow: 0px 4px 19px -8px #cbc1c1;
    width: 100%;
  }
    .header-floating-open {
    top: -15px;
    transform: scale(0.9) translateY(90px);
    box-shadow: 0px 4px 19px -8px #cbc1c1;
    width: 100%;
  }
  .floating {
    top: 0px;
    transform: translateY(0px) translateX(-10px);
    box-shadow: 0px 4px 19px 0px #cbc1c1;
    width: 100%;
  }
  .incomplete-row{
    background: #ececec;
    opacity: 0.3;
  }
</style>
